import styles from './Id.module.scss'

const RENAME_NOTICE_LAST_DATE = '2026-11-03'

const showsCompanyRenameNotice = (date: string): boolean => {
  return typeof date === 'string' && date.slice(0, 10) <= RENAME_NOTICE_LAST_DATE
}

const CompanyRenameNotice: React.FC<{ date: string }> = ({ date }) => {
  if (!showsCompanyRenameNotice(date)) {
    return null
  }

  return (
    <p className={styles.renameNotice}>
      「株式会社アイスリーデザイン」は、2026年11月4日に「Aitria株式会社」に社名変更いたしました。
    </p>
  )
}

export default CompanyRenameNotice
